module.exports = __webpack_public_path__ + "static/media/malmo.b7627ccd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Hero/images/malmo.jpg
// module id = 438
// module chunks = 0